/**
 * Word Lists for Daily Word Game
 *
 * SOLUTION_WORDS: ~500 common 5-letter English words used as daily solutions
 * VALID_GUESSES: ~3000 additional valid 5-letter words that can be guessed
 */

/** Solution words - common, recognizable 5-letter English words */
export const SOLUTION_WORDS: string[] = [
  'ABOUT','ABOVE','ABUSE','ACTOR','ACUTE','ADMIT','ADOPT','ADULT','AFTER','AGAIN',
  'AGENT','AGREE','AHEAD','ALARM','ALBUM','ALERT','ALIEN','ALIGN','ALIVE','ALLEY',
  'ALLOW','ALONE','ALONG','ALTER','AMONG','ANGEL','ANGER','ANGLE','ANGRY','APART',
  'APPLE','APPLY','ARENA','ARGUE','ARISE','ASIDE','ASSET','AVOID','AWAKE','AWARD',
  'AWARE','BACON','BADGE','BADLY','BAKER','BASIC','BASIS','BEACH','BEGUN','BEING',
  'BENCH','BERRY','BIBLE','BLADE','BLAME','BLAND','BLANK','BLAST','BLAZE','BLEED',
  'BLEND','BLESS','BLIND','BLOCK','BLOOD','BLOOM','BLOWN','BOARD','BONUS','BOOTH',
  'BOUND','BRAIN','BRAND','BRAVE','BREAD','BREAK','BREED','BRICK','BRIEF','BRING',
  'BROAD','BROKE','BROWN','BRUSH','BUILD','BUILT','BURST','BUYER','CABIN','CANAL',
  'CANDY','CARRY','CATCH','CAUSE','CEDAR','CHAIN','CHAIR','CHARM','CHART','CHASE',
  'CHEAP','CHECK','CHEEK','CHESS','CHEST','CHIEF','CHILD','CHINA','CHUNK','CIVIL',
  'CLAIM','CLASS','CLEAN','CLEAR','CLIMB','CLING','CLOCK','CLONE','CLOSE','CLOTH',
  'CLOUD','COACH','COAST','COLOR','COUCH','COULD','COUNT','COURT','COVER','CRACK',
  'CRAFT','CRANE','CRASH','CRAZY','CREAM','CRIME','CROSS','CROWD','CROWN','CRUEL',
  'CRUSH','CURVE','CYCLE','DAILY','DANCE','DEATH','DEBUT','DELAY','DELTA','DENSE',
  'DEPTH','DEVIL','DIRTY','DOUBT','DOZEN','DRAFT','DRAIN','DRAMA','DRANK','DRAWN',
  'DREAM','DRESS','DRIED','DRIFT','DRINK','DRIVE','DROVE','DYING','EAGER','EARLY',
  'EARTH','EIGHT','ELDER','ELECT','ELITE','EMPTY','ENEMY','ENJOY','ENTER','ENTRY',
  'EQUAL','ERROR','EVENT','EVERY','EXACT','EXIST','EXTRA','FAINT','FAITH','FALSE',
  'FAULT','FEAST','FENCE','FEVER','FIBER','FIELD','FIFTH','FIFTY','FIGHT','FINAL',
  'FIRST','FIXED','FLAME','FLASH','FLEET','FLESH','FLOAT','FLOOD','FLOOR','FLOUR',
  'FLUID','FOCUS','FORCE','FORGE','FORTH','FOUND','FRAME','FRANK','FRAUD','FRESH',
  'FRONT','FROST','FRUIT','FULLY','GIANT','GIVEN','GLASS','GLOBE','GLOOM','GLORY',
  'GLOVE','GOING','GRACE','GRADE','GRAIN','GRAND','GRANT','GRAPH','GRASP','GRASS',
  'GRAVE','GREAT','GREEN','GREET','GRIEF','GRILL','GRIND','GROSS','GROUP','GROWN',
  'GUARD','GUESS','GUEST','GUIDE','GUILT','HABIT','HAPPY','HARSH','HAVEN','HEART',
  'HEAVY','HENCE','HONOR','HORSE','HOTEL','HOUSE','HUMAN','HUMOR','HURRY','IDEAL',
  'IMAGE','IMPLY','INDEX','INNER','INPUT','ISSUE','IVORY','JOINT','JUDGE','JUICE',
  'KNIFE','KNOCK','KNOWN','LABEL','LARGE','LASER','LATER','LAUGH','LAYER','LEARN',
  'LEASE','LEAST','LEAVE','LEGAL','LEMON','LEVEL','LIGHT','LIMIT','LINEN','LIVER',
  'LOOSE','LOVER','LOWER','LUCKY','LUNCH','LYING','MAGIC','MAJOR','MAKER','MANOR',
  'MARCH','MATCH','MAYOR','MEANT','MEDIA','MERCY','MERIT','METAL','MIGHT','MINOR',
  'MINUS','MIXED','MODEL','MONEY','MONTH','MORAL','MOTOR','MOUNT','MOUSE','MOUTH',
  'MOVED','MOVIE','MUSIC','NAVAL','NERVE','NEVER','NEWLY','NIGHT','NOBLE','NOISE',
  'NORTH','NOTED','NOVEL','NURSE','OCEAN','OFFER','OFTEN','ORDER','OTHER','OUTER',
  'OWNER','PAINT','PANEL','PANIC','PAPER','PARTY','PASTE','PATCH','PAUSE','PEACE',
  'PEACH','PENNY','PHASE','PHONE','PHOTO','PIANO','PIECE','PILOT','PITCH','PLACE',
  'PLAIN','PLANE','PLANT','PLATE','PLAZA','PLEAD','POINT','POUND','POWER','PRESS',
  'PRICE','PRIDE','PRIME','PRINT','PRIOR','PRIZE','PROOF','PROUD','PROVE','PULSE',
  'PUNCH','PUPIL','QUEEN','QUEST','QUICK','QUIET','QUITE','QUOTE','RADAR','RADIO',
  'RAISE','RANGE','RAPID','RATIO','REACH','READY','REALM','REBEL','REFER','REIGN',
  'RELAX','REPLY','RIGHT','RIGID','RIVAL','RIVER','ROBIN','ROBOT','ROCKY','ROMAN',
  'ROUGE','ROUGH','ROUND','ROUTE','ROYAL','RUGBY','RULER','RURAL','SAINT','SALAD',
  'SCALE','SCENE','SCOPE','SCORE','SENSE','SERVE','SEVEN','SHALL','SHAME','SHAPE',
  'SHARE','SHARP','SHEET','SHELF','SHELL','SHIFT','SHINE','SHIRT','SHOCK','SHOOT',
  'SHORT','SHOUT','SIGHT','SINCE','SIXTH','SIXTY','SIZED','SKILL','SKULL','SLAVE',
  'SLEEP','SLICE','SLIDE','SLOPE','SMART','SMELL','SMILE','SMOKE','SNAKE','SOLAR',
  'SOLID','SOLVE','SORRY','SOUTH','SPACE','SPARE','SPARK','SPEAK','SPEED','SPEND',
  'SPENT','SPIKE','SPINE','SPLIT','SPOKE','SPRAY','SQUAD','STACK','STAFF','STAGE',
  'STAKE','STAND','STARK','START','STATE','STEAK','STEAL','STEAM','STEEL','STEEP',
  'STEER','STERN','STICK','STILL','STOCK','STONE','STOOD','STORE','STORM','STORY',
  'STOVE','STRIP','STUCK','STUDY','STUFF','STYLE','SUGAR','SUITE','SUPER','SURGE',
  'SWAMP','SWEAR','SWEEP','SWEET','SWEPT','SWIFT','SWING','SWORD','SWORN','SWUNG',
  'TABLE','TASTE','TEACH','TEETH','THANK','THEFT','THEME','THICK','THING','THINK',
  'THIRD','THORN','THOSE','THREE','THREW','THROW','THUMB','TIGER','TIGHT','TIMER',
  'TIRED','TITLE','TODAY','TOKEN','TOTAL','TOUCH','TOUGH','TOWEL','TOWER','TOXIC',
  'TRACE','TRACK','TRADE','TRAIL','TRAIN','TRAIT','TRASH','TREAT','TREND','TRIAL',
  'TRIBE','TRICK','TROOP','TRUCK','TRULY','TRUMP','TRUNK','TRUST','TRUTH','TUMOR',
  'TWICE','TWIST','ULTRA','UNCLE','UNDER','UNION','UNITE','UNITY','UNTIL','UPPER',
  'UPSET','URBAN','USAGE','USUAL','VALID','VALUE','VIDEO','VIGOR','VIRAL','VIRUS',
  'VISIT','VITAL','VIVID','VOCAL','VOICE','VOTER','WASTE','WATCH','WATER','WEIGH',
  'WEIRD','WHALE','WHEAT','WHEEL','WHERE','WHICH','WHILE','WHITE','WHOLE','WHOSE',
  'WIDOW','WIDTH','WOMAN','WORLD','WORRY','WORSE','WORST','WORTH','WOULD','WOUND',
  'WRIST','WRITE','WRONG','WROTE','YACHT','YIELD','YOUNG','YOUTH',
];

/** Additional valid guesses (can be guessed but won't appear as solutions) */
export const VALID_GUESSES: string[] = [
  'AAHED','AALII','ABASE','ABASH','ABATE','ABBEY','ABBOT','ABHOR','ABIDE','ABLED',
  'ABODE','ABORT','ABYSS','ACORN','ACRID','ADAPT','ADDED','ADDER','ADEPT','ADIEU',
  'ADMIN','ADOBE','AEGIS','AFIRE','AFOUL','AGAPE','AGATE','AGAVE','AGING','AGLOW',
  'AGONY','AIDED','AIDER','AIMED','AIMER','AISLE','ALGAE','ALIBI','ALLOT','ALLOY',
  'ALOFT','ALOHA','ALPHA','AMASS','AMAZE','AMBER','AMBLE','AMEND','AMPLE','AMUSE',
  'ANKLE','ANNEX','ANNOY','ANTIC','ANVIL','AORTA','APHID','APPLE','ARDOR','ATOLL',
  'ATTIC','AUDIO','AUDIT','AUGUR','AVERT','AVIAN','AXIOM','AZURE','BADGE','BAGEL',
  'BAGGY','BANAL','BARON','BASIN','BATCH','BATON','BAYOU','BEAST','BEECH','BEGAN',
  'BEIGE','BELLY','BELOW','BERET','BEZEL','BILGE','BINGO','BIOME','BIRCH','BISON',
  'BLACK','BLARE','BLAZE','BLIMP','BLINK','BLISS','BLITZ','BLOAT','BLOWN','BLUFF',
  'BLUNT','BLURT','BLUSH','BOGEY','BOGUS','BOLTS','BONGO','BORAX','BORNE','BOSSY',
  'BOUGH','BOXER','BRACE','BRAID','BRAKE','BRASH','BRAWN','BRAZE','BRIBE','BRINY',
  'BRISK','BROIL','BROOK','BROOD','BRUNT','BUDGE','BUGGY','BUGLE','BULGE','BULKY',
  'BULLY','BUNCH','BUNNY','BURLY','BURNS','BUSHY','CABAL','CACHE','CADET','CADRE',
  'CAGEY','CAIRN','CAMEL','CAMEO','CANOE','CAPER','CARGO','CAROL','CASTE','CATNIP',
  'CAULK','CAVIL','CEASE','CHAFE','CHAFF','CHALK','CHAMP','CHANT','CHAOS','CHAPS',
  'CHARM','CHEEK','CHEER','CHESS','CHICK','CHIDE','CHILI','CHIME','CHIRP','CHOMP',
  'CHORD','CHORE','CHOSE','CHURN','CIDER','CIGAR','CINCH','CIVIC','CLACK','CLASP',
  'CLAVE','CLEAT','CLERK','CLIFF','CLIMB','CLOAK','CLOG','CLOUT','CLOWN','CLUCK',
  'CLUMP','CLUNG','COBRA','COCOA','COMET','COMIC','COMMA','CONCH','CORAL','CORDS',
  'CORGI','CORPS','COUPE','CRAVE','CRAWL','CRAZE','CREAK','CREED','CREEK','CREEP',
  'CREST','CRIMP','CRISP','CROAK','CRONE','CRONY','CROUCH','CRUEL','CRUMB','CUBIC',
  'CUMIN','CUPID','CURRY','CUTIE','CYNIC','DADDY','DAILY','DAISY','DANCE','DANDY',
  'DATUM','DEALT','DECAY','DECAL','DECOR','DECOY','DECRY','DEITY','DELVE','DEMON',
  'DENIM','DEPOT','DERBY','DETOX','DEUCE','DIARY','DIGIT','DIMLY','DINER','DINGO',
  'DINGY','DISCO','DITCH','DIZZY','DODGE','DOGMA','DOING','DOLLY','DONOR','DONUT',
  'DOPEY','DOUBT','DOUGH','DOWDY','DOWEL','DRAPE','DRAWL','DREAD','DREED','DRESS',
  'DROOL','DROOP','DROWN','DRUID','DRUNK','DRYLY','DUCHY','DUMMY','DUNCE','DUSKY',
  'DUSTY','DWARF','DWELL','EATER','EBONY','EDICT','EIGHT','ELBOW','ELDER','ELFIN',
  'ELITE','ELOPE','ELUDE','ELVES','EMBED','EMBER','EMCEE','EMOJI','EMOTE','ENDOW',
  'ENEMA','ENSUE','ENVOY','EPOCH','EQUIP','ERODE','ERUPT','ESSAY','ETHER','ETHIC',
  'EVADE','EVENT','EVICT','EVOKE','EXALT','EXCEL','EXERT','EXILE','EXPAT','EXPEL',
  'EXUDE','FABLE','FACET','FAIRY','FAKER','FANCY','FARCE','FAUNA','FEAST','FEIGN',
  'FEINT','FELLA','FELON','FEMUR','FERRY','FETAL','FETCH','FETID','FIBRE','FICUS',
  'FIERY','FILTH','FINCH','FJORD','FLACK','FLAIR','FLAKY','FLANK','FLARE','FLASK',
  'FLAXY','FLECK','FLESH','FLICK','FLING','FLINT','FLIRT','FLOCK','FLORA','FLOSS',
  'FLOUR','FLOUT','FLOWN','FLUFFY','FLUKE','FLUNG','FLUNK','FLUSH','FLUTE','FOAMY',
  'FOCAL','FOGGY','FOLLY','FORAY','FORGE','FORGO','FORTE','FORUM','FOSSIL','FOWL',
  'FRAIL','FREAK','FREED','FRENZY','FRIAR','FRILL','FRISK','FRITZ','FROCK','FROND',
  'FROTH','FROZE','FRUGAL','FUNGI','FUNKY','FUNNY','FURRY','GAILY','GAMMA','GAUDY',
  'GAUGE','GAUNT','GAUZE','GAVEL','GAWKY','GAZED','GECKO','GEEKY','GENIE','GENRE',
  'GHOST','GIDDY','GIRTH','GIVEN','GLAND','GLARE','GLEAM','GLEAN','GLEE','GLIDE',
  'GLINT','GLOAT','GLOOMY','GLOSS','GOLEM','GONNA','GOOFY','GOOSE','GORGE','GOUGE',
  'GOURD','GRAFT','GRAPE','GRATE','GRAVEL','GRAZE','GREED','GREEDY','GREET','GRIEF',
  'GRIME','GRIMY','GRIPE','GRITS','GROAN','GROIN','GROOM','GROPE','GROSS','GROUT',
  'GROVE','GROWL','GRUEL','GRUFF','GRUNT','GUAVA','GUILE','GUISE','GULCH','GULLY',
  'GUMMY','GUPPY','GUSTO','GUSTY','GYPSY','HAIRY','HALVE','HANDY','HARSH','HASTE',
  'HASTY','HATCH','HAUNT','HAVEN','HAVOC','HAZEL','HEADS','HEADY','HEARD','HEAVE',
  'HEDGE','HEFTY','HELIX','HELLO','HENNA','HERBS','HERON','HILLY','HINGE','HIPPY',
  'HITCH','HOARD','HOBBY','HOLLY','HOMER','HONEY','HOOPS','HOOKY','HOPED','HORDE',
  'HORNY','HOVER','HOWDY','HUBBY','HUFFY','HUMPS','HUMUS','HUNKY','HURTS','HUSKY',
  'HYENA','HYPER','ICILY','ICING','IDIOM','IDIOT','IGLOO','ILIAC','IMAGO','IMBUE',
  'IMPEL','INANE','INCUR','INEPT','INFER','INGOT','INLET','INTER','IONIC','IRONY',
  'IVORY','JAZZY','JELLY','JENNY','JERKY','JEWEL','JIFFY','JIMMY','JOKER','JOLLY',
  'JOUST','JUDGE','JUICE','JUICY','JUMBO','JUMPY','JUROR','KARMA','KAYAK','KEBAB',
  'KEYED','KHAKI','KINKY','KIOSK','KITTY','KNACK','KNEAD','KNEEL','KNELT','KNACK',
  'KOALA','KUDOS','LADEN','LADLE','LAGER','LANCE','LANKY','LAPEL','LAPSE','LARGO',
  'LARVA','LATCH','LATEX','LATHE','LATTE','LAYER','LEACH','LEAFY','LEAKY','LEAPT',
  'LEASE','LEDGE','LEFTY','LEGGY','LEMMA','LEVER','LLAMA','LLANO','LOAFS','LOBBY',
  'LOCAL','LODGE','LOFTY','LOGIC','LONER','LOOPY','LORRY','LOTUS','LOUSY','LOVED',
  'LUCID','LUMPY','LUNAR','LUNGE','LUSTY','LYRIC','MACHO','MACRO','MADLY','MAGMA',
  'MANGO','MANLY','MAPLE','MARSH','MASON','MASSE','MAXIM','MEALY','MEATY','MEDAL',
  'MEDIC','MELEE','MELON','MESSY','MICRO','MIDST','MIMIC','MINCE','MISTY','MITER',
  'MITRE','MOCHA','MODAL','MOGUL','MOIST','MOLAR','MOLDY','MONDO','MOOSE','MOSSY',
  'MOTEL','MOTIF','MOTTO','MOURN','MOUSY','MOVER','MUCUS','MUDDY','MUMMY','MUNCH',
  'MURAL','MURKY','MUSHY','MUSKY','MUSTY','MYRRH','NACHO','NAIVE','NANNY','NASTY',
  'NATTY','NAVEL','NEEDY','NERDY','NINNY','NINJA','NITTY','NUTTY','NYLON','OAKEN',
  'OASIS','OCCUR','OLIVE','OMEGA','ONSET','OPERA','OPTIC','ORBIT','ORGAN','OTTER',
  'OUGHT','OUNCE','OUTDO','OVARY','OVERT','OXIDE','OZONE','PADDY','PAGAN','PAGER',
  'PALSY','PANDA','PANSY','PAPAL','PARKA','PARRY','PARSE','PARTS','PASTY','PATIO',
  'PATSY','PAUSE','PAYER','PEAKY','PEARL','PECAN','PEDAL','PERCH','PERIL','PERKY',
  'PESKY','PETAL','PETTY','PIETY','PIGGY','PIXEL','PIXIE','PIZZA','PLAID','PLANK',
  'PLASH','PLATY','PLAZA','PLEAT','PLIED','PLIER','PLOP','PLUCK','PLUMB','PLUME',
  'PLUMP','PLUNK','PLUSH','PLUTO','POACH','POKER','POLAR','POLKA','POLYP','POOCH',
  'POPPY','PORCH','POSED','POSIT','POSSE','POTTY','POUTY','PRANK','PRAWN','PREEN',
  'PRICK','PRIED','PRIMO','PRIMP','PRISM','PRIVY','PROBE','PROMO','PRONE','PRONG',
  'PROSE','PROXY','PRUDE','PRUNE','PSALM','PUDGY','PULPY','PUNCH','PUREE','PURGE',
  'PUSHY','PUTTY','PYGMY','QUACK','QUAFF','QUAIL','QUAKE','QUALM','QUASI','QUEEN',
  'QUEER','QUELL','QUERY','QUEUE','QUILT','QUIRK','QUOTA','RABBI','RABID','RACER',
  'RADAR','RADII','RADON','RAINY','RAJAH','RALLY','RAMEN','RANCH','RANDY','RAVEN',
  'RAYON','RAZOR','REBUS','RECAP','REDUX','REEDY','REFIT','REGAL','REHAB','REIGN',
  'RELAY','RELIC','REMIT','RENAL','REPAY','REPEL','RESET','RESIN','RETCH','RETRO',
  'RETRY','REUSE','REVEL','RIDER','RIDGE','RIFLE','RIGOR','RINSE','RISEN','RISKY',
  'RIVET','ROACH','ROAST','ROCKY','RODEO','ROGUE','ROOST','ROSIE','ROUGE','ROWDY',
  'ROVER','ROYAL','RUDDY','RUMMY','RUMOR','RUNNY','RUPEE','RUSTY','SADLY','SAFER',
  'SALTY','SALVE','SALVO','SANDY','SAPPY','SASSY','SAUNA','SAVVY','SCALD','SCALP',
  'SCAM','SCANT','SCARE','SCARF','SCARY','SCOUT','SCOWL','SCRAM','SCRAP','SCREE',
  'SCREW','SCRUB','SEEDY','SEIZE','SENOR','SEPIA','SERVO','SETUP','SEWER','SHADY',
  'SHALE','SHALT','SHANK','SHARK','SHAWL','SHEAF','SHEAR','SHEEN','SHEER','SHIRE',
  'SHIRK','SHOAL','SHONE','SHOOK','SHORE','SHOVE','SHOWY','SHRUB','SHRUG','SHUNT',
  'SIEGE','SIEVE','SILKY','SILLY','SINCE','SINEW','SISSY','SIREN','SKIMP','SKIRT',
  'SKUNK','SLACK','SLAIN','SLANG','SLANT','SLATE','SLICK','SLIME','SLIMY','SLING',
  'SLINK','SLOTH','SLUGS','SLUMP','SLUNG','SLURP','SMACK','SMART','SMEAR','SMELT',
  'SMIRK','SMITE','SMOCK','SMOKY','SNACK','SNAFU','SNAGS','SNAIL','SNARE','SNARL',
  'SNEAK','SNEER','SNIDE','SNIFF','SNIPE','SNOOP','SNORE','SNORT','SNOUT','SNOWY',
  'SOAPY','SOBER','SOCLE','SOLAR','SONAR','SONIC','SOOTH','SOOTY','SPADE','SPANK',
  'SPASM','SPAWN','SPEAR','SPECK','SPELL','SPICE','SPICY','SPIEL','SPIKE','SPILL',
  'SPINY','SPIRE','SPITE','SPLEEN','SPOKE','SPOOK','SPOOL','SPOON','SPORE','SPORT',
  'SPOUT','SPREE','SPRIG','SPUNK','SPURN','SQUAT','SQUID','STAID','STAIN','STAIR',
  'STALE','STALK','STALL','STAMP','STANK','STAPH','STARE','STASH','STEAD','STEED',
  'STEW','STIFF','STING','STINK','STINT','STOIC','STOKE','STOLE','STOMP','STOOL',
  'STOOP','STORK','STOUT','STRAP','STRAW','STRAY','STREW','STRIP','STRUM','STRUT',
  'STUCK','STUDS','STUDY','STUMP','STUNG','STUNK','STUNT','SUGAR','SULKY','SULTRY',
  'SUNNY','SUPER','SURGE','SURLY','SUSHI','SWAMP','SWANK','SWATH','SWEAT','SWELL',
  'SWEPT','SWILL','SWINE','SWIRL','SWOON','SWOOP','SYRUP','TABBY','TACIT','TACKY',
  'TAFFY','TAINT','TALLY','TALON','TAMER','TANGO','TANGY','TAPIR','TARDY','TAROT',
  'TAUNT','TAWNY','TEDDY','TEMPO','TENET','TENOR','TEPID','THEIR','THETA','THICK',
  'THIEF','THIGH','THONG','THORN','THREE','THROW','THUD','TIARA','TIDAL','TIGER',
  'TIMID','TIPSY','TOAST','TOKEN','TOMMY','TONIC','TOPAZ','TORCH','TORSO','TOTEM',
  'TRACT','TRAMP','TRAPS','TRAWL','TREAD','TREKS','TRIAD','TRICE','TRIED','TRIGS',
  'TRILL','TRIPE','TRITE','TROLL','TROTH','TROUT','TRUCE','TRULY','TULIP','TUMOR',
  'TUNIC','TURBO','TUTOR','TWANG','TWEAK','TWEED','TWEET','TWIGS','TWILL','TWINE',
  'TWIRL','TWIST','UDDER','ULCER','ULTRA','UMBRA','UNCUT','UNDID','UNDUE','UNFIT',
  'UNIFY','UNITE','UNITY','UNLIT','UNMET','UNSAY','UNTIE','UNTIL','UNWED','UPPER',
  'UPSET','USHER','UTTER','VALET','VALID','VALOR','VALVE','VAPID','VAULT','VEGGIE',
  'VENOM','VENUE','VERGE','VERSE','VIBES','VIGOR','VILLA','VINYL','VIOLA','VIPER',
  'VISOR','VISTA','VIVID','VIXEN','VODKA','VOGUE','VOILA','VOUCH','VOWEL','VULVA',
  'WACKY','WADER','WAFER','WAGER','WAGON','WAIST','WALTZ','WEARY','WEDGE','WEEDY',
  'WEIGH','WENCH','WHACK','WHALE','WHEAT','WHERE','WHICH','WHILE','WHIFF','WHINE',
  'WHINY','WHIRL','WHISK','WHITE','WHOLE','WHOSE','WIDEN','WIDOW','WIELD','WINDY',
  'WIRED','WITCH','WITTY','WOKEN','WOODY','WOOZY','WORDY','WORLD','WORRY','WORSE',
  'WORST','WRATH','WREAK','WRECK','WRING','WROTE','YACHT','YEARN','YEAST','YODEL',
  'YOUNG','YOUTH','ZEBRA','ZESTY','ZIPPY','ZONAL',
];

/**
 * Check if a word is valid (either a solution word or valid guess)
 */
export function isValidWord(word: string): boolean {
  const upper = word.toUpperCase();
  return SOLUTION_WORDS.includes(upper) || VALID_GUESSES.includes(upper);
}

/**
 * Get the total number of solution words available
 */
export function getSolutionCount(): number {
  return SOLUTION_WORDS.length;
}
